import $ from 'jquery'
import Swiper from 'swiper'

// もっとみる
const moremoreClick = () => {
  $('.js-design-detail-more-more').on('click', '', () => {
    $('.js-design-detail-price-table tr:gt(2)').fadeIn(1000)
    $('.js-design-detail-more-more').fadeOut(1000).remove()
  })
}

const start = () => {
  // デザイン詳細の価格表の初期表示はなし
  $('.js-design-detail-price-table tr:gt(2)').hide()

  $('.js-tileWrap').each((_, tileWrap) => {
    let $tiles = $(tileWrap).find('.js-tile')
    let max = Math.max(...$tiles.map((_, tile) => $(tile).outerHeight()))
    $tiles.each((_, tile) => $(tile).outerHeight(max))
    $(tileWrap).css('background', `linear-gradient(to top, rgba(255,255,255,1)  0,rgba(255,255,255,1)  ${max}px,rgba(250,250,250,1) ${max}px,rgba(250,250,250,1) ${max + 70}px,rgba(255,255,255,0) ${max + 70}px,rgba(255,255,255,0) 100%`)
  })

  $('.js-switch-price-table').on('click', '', (e) => {
    $(e.currentTarget).siblings().removeClass('active')
    $(e.currentTarget).addClass('active')
    $(e.currentTarget).closest('.m-styleDetailPrice').find('.m-priceTable').removeClass('active')
    let target = '.js-price-table-' + $(e.currentTarget).data('target')
    $(e.currentTarget).closest('.m-styleDetailPrice').find(target).addClass('active')
  })
}

const showAssortImage = (number) => {
  let maxAssortNumber = $('.js-assort-image').length

  if (number < 0) number = maxAssortNumber - 1
  if (number >= maxAssortNumber) number = 0

  let images = $('.js-assort-image')
  let buttons = $('.js-assort-change')

  for (let i = 0; i < maxAssortNumber; i++) {
    if (i === number) {
      $(images[i]).show()
      $(buttons[i]).addClass('a-assortChanger__changeButton__active')
    } else {
      $(images[i]).hide()
      $(buttons[i]).removeClass('a-assortChanger__changeButton__active')
    }
  }
}

const changeAssortImage = () => {
  $('.js-assort-change').on('touchstart click', (e) => {
    // touchとclickの二重動作防止
    e.preventDefault()

    let number = $(e.target).data('assort-number')
    showAssortImage(number)
  })

  $('.js-assort-next').on('touchstart click', (e) => {
    // touchとclickの二重動作防止
    e.preventDefault()

    let showedNumber = $('.js-assort-image:visible').data('assort-image-number')
    showAssortImage(showedNumber + 1)
  })

  $('.js-assort-back').on('touchstart click', (e) => {
    // touchとclickの二重動作防止
    e.preventDefault()

    let showedNumber = $('.js-assort-image:visible').data('assort-image-number')
    showAssortImage(showedNumber - 1)
  })

  // 初期表示
  showAssortImage(0)
}

const changeImageDepth = () => {
  $('.js-design-thumbnail-back').on({
    'mouseenter': () => {
      $('.js-design-thumbnail-container-back').css('z-index', '9')
    },
    'mouseleave': () => {
      $('.js-design-thumbnail-container-back').css('z-index', '')
    }
  })
}

const slideView = () => {
  Swiper('.o-stylePrintinfinity .swiper-container', {
    loop: true,
    slidesPerView: 1,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 0,
    autoplay: 5000,
    autoplayDisableOnInteraction: false,
    speed: 1000
  })

  Swiper('.swiper-container--sizes', {
    loop: false,
    slidesPerView: 1,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    pagination: '.swiper-pagination',
    spaceBetween: 30,
    speed: 1000
  })

  Swiper('.swiper-container--tab', {
    loop: true,
    slidesPerView: 1,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 0,
    parallax: true,
    speed: 1000,
    onSlideChangeStart: function (e) {
      $('.m-priceTable').removeClass('active')
      $('.m-priceTable').eq(e.realIndex).addClass('active')
    }
  })
}

$(() => {
  start()
  moremoreClick()
  changeAssortImage()
  changeImageDepth()
  slideView()
})



// WEBPACK FOOTER //
// ./src/scripts/page/style.detail.js